<script setup>
const benefits = [
  { title: 'benefits.items.0.title', text: 'benefits.items.0.text' },
  { title: 'benefits.items.1.title', text: 'benefits.items.1.text' },
  { title: 'benefits.items.2.title', text: 'benefits.items.2.text' },
];

const { openContactModal } = useContactModal();

const { tp } = useTypograf();
</script>

<template>
  <section class="section-benefits">
    <div class="container">
      <div class="section-benefits__inner">
        <BlocksLazyVideo
          src="/videos/benefits.mp4"
          poster="/images/video-covers/benefits.jpg"
          class="section-benefits__video"
        />

        <div class="section-benefits__bg" />

        <div class="section-benefits__content">
          <div class="section-benefits__head">
            <h2 class="section-benefits__title">
              <span
                class="section-benefits__font section-benefits__font--title"
              >
                {{ tp($t('benefits.title')) }}
              </span>
            </h2>

            <p class="section-benefits__text">
              <span class="section-benefits__font section-benefits__font--text">
                {{ tp($t('benefits.text')) }}
              </span>
            </p>
          </div>

          <div class="section-benefits__cards">
            <CardBenefit
              v-for="(benefit, index) in benefits"
              :key="index"
              :title="$t(benefit.title)"
              :text="$t(benefit.text)"
              class="section-benefits__card"
            />
          </div>

          <UiButton
            type="button"
            :text="$t('buttons.touch')"
            theme="white-purple"
            class="section-benefits__button"
            @click="openContactModal"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.section-benefits {
  &__inner {
    position: relative;

    @include media-breakpoint-desktop {
      padding-block-start: em(108);
      padding-inline-end: em(20);
      padding-block-end: em(90);
      padding-inline-start: em(68);

      padding-top: em(108);
      padding-bottom: em(90);
      padding-inline-start: em(68);
      padding-inline-end: em(20);
    }
  }

  &__video,
  &__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;

    @include media-breakpoint-mobile {
      height: em(189);
    }
  }

  &__bg {
    background: transparent url('/images/section/benefits/bg.png') no-repeat
      bottom left / cover;

    @include media-breakpoint-mobile {
      background-image: url('/images/section/benefits/bg-mobile.png');
    }
  }

  &__content {
    position: relative;

    @include media-breakpoint-mobile {
      padding-top: em(120);
    }
  }

  &__head {
    margin-bottom: em(102);

    @include media-breakpoint-mobile {
      margin-bottom: em(36);
      text-align: center;
    }
  }

  &__title {
    margin-bottom: em(65);
    display: inline-block;
    padding-bottom: em(10);

    @include gradient-text(
      linear-gradient(90deg, $color-second-1 32.78%, $color-white 100%)
    );
  }

  &__font {
    &--title {
      font-size: em(80);
      font-weight: $font-weight-semi-bold;
      line-height: 1;

      @include media-breakpoint-mobile {
        font-size: em(30);
      }
    }

    &--text {
      font-size: em(40);
      line-height: em(48, 40);

      @include media-breakpoint-mobile {
        font-size: em(16);
        line-height: em(19, 16);
      }
    }
  }

  &__text {
    max-width: em(970);
    color: $color-white;

    @include media-breakpoint-mobile {
      color: $color-black;
      padding-block: 0;
      padding-inline: em(25);
    }
  }

  &__cards {
    max-width: em(1043);
    gap: em(13);
    margin-bottom: em(97);

    @include media-breakpoint-desktop {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    @include media-breakpoint-mobile {
      margin-bottom: em(44);
    }
  }

  &__card {
    & + & {
      @include media-breakpoint-mobile {
        margin-top: em(8);
      }
    }
  }

  &__button {
    @include media-breakpoint-mobile {
      margin: 0 auto;
    }
  }
}
</style>
